import React from "react";
import NewsAndNotifiactionSection from "../../components/Investor/NewsAndNotification.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const NewsAndNotificationPage = () => {
  return (
    <>
      <MetaComponent
        title="Aptech investors news and notifications."
        desc="Get all the latest announcements, notices, news and notifications about Aptech Ltd here. Aptech is a leading brand in education and vocational training."
        keywords="Aptech news and notifications, Aptech announcements, Aptech investor relations."
      />
    
      <NewsAndNotifiactionSection />
    </>
  );
};

export default NewsAndNotificationPage;
